/**
 * Props that make a controlled MUI Accordion accessible when its header holds
 * other interactive controls (e.g. the chart view toggle).
 *
 * By default AccordionSummary renders as role="button" and its expand icon is
 * aria-hidden and unfocusable. Any button inside the header then becomes a
 * button nested in a button (WCAG 4.1.2), and keyboard users cannot reach the
 * expand control at all.
 *
 * Instead, the header becomes a plain container (clicking it still toggles),
 * and the expand icon becomes the real, focusable toggle button with
 * aria-expanded/aria-controls. Ids are derived from `id`, so each accordion on
 * a page must use a different one.
 */
export function accordionA11yProps({id, expanded, label}) {
  const headerId = `${id}-header`;
  const contentId = `${id}-content`;

  return {
    summaryProps: {
      id: headerId,
      role: undefined,
      tabIndex: null,
      'aria-expanded': undefined,
      IconButtonProps: {
        component: 'button',
        type: 'button',
        role: undefined,
        tabIndex: 0,
        'aria-hidden': undefined,
        'aria-label': label,
        'aria-expanded': expanded,
        'aria-controls': contentId,
      },
    },
    detailsProps: {
      id: contentId,
      role: 'region',
      'aria-labelledby': headerId,
    },
  };
}
